import {UUIDType} from '@shared/models';

export const DOWNLOAD_HISTORY_CREATED_EVENT = 'download-history-created';
export const DOWNLOAD_HISTORY_UPDATED_EVENT = 'download-history-updated';

export const DOWNLOAD_HISTORY_STATUS = {
  STARTING: 'Starting',
  ERROR: 'Error',
  MERGING: 'Merging',
  COMPLETED: 'Completed',
  PROCESSING: 'Processing'
} as const;

export type DownloadHistoryStatusType = (typeof DOWNLOAD_HISTORY_STATUS)[keyof typeof DOWNLOAD_HISTORY_STATUS];

export interface DownloadHistoryBasePayload {
  operationId: UUIDType;
  tenantId: UUIDType;
  userId: UUIDType;
  status: keyof typeof DOWNLOAD_HISTORY_STATUS;
  statusAlias: DownloadHistoryStatusType;
  projectId: UUIDType;
  filename: string;
  progress: number;
}

export interface DownloadHistoryUpdatedPayload extends DownloadHistoryBasePayload {
  downloadUrl: string;
  token: string;
}

export interface DownloadHistoryUserModel extends DownloadHistoryBasePayload {
  updatedAt: string;
  createdAt: string;
}
